import { ReactNode, useState } from "react";
import NodataAvailable from "../../assets/images/NodataAvailable.svg";
import classes from "./style.module.scss";
import React from "react";
export type Column<T, K extends keyof T = keyof T> = {
  key: string;
  header: string;
  headerWidget?: ReactNode;
  className?: string;
  type?: "DROPDOWN" | "INPUT" | "STRING" | "ELEMENT" | 'NUMBER';
  render?: (value: T[K], row: T, rowIndex?: number, isExpanded?: boolean) => ReactNode;
  headerClassName?: string;
};

type TableProps<T> = {
  columns: Column<T>[];
  data: T[];
  onRowClick?: (row: T) => void;
  renderExpandedRow?: (row: T) => ReactNode;
  isRowExpandable?: (row: T) => boolean;
  rowClickAction?: "expand" | "navigate" | "both";
  height?: string;
  loading?: boolean,
};

export default function TableView<T>({
  columns,
  data,
  onRowClick,
  renderExpandedRow,
  rowClickAction,
  isRowExpandable,
  height,
  loading = false,
}: TableProps<T>) {
  const [expandedRows, setExpandedRows] = useState<Set<number>>(new Set());

  const toggleRow = (index: number) => {
    const newSet = new Set(expandedRows);
    newSet.has(index) ? newSet.delete(index) : newSet.add(index);
    setExpandedRows(newSet);
  };

  return (
    <div
      className={`${classes.tablewrapper} bg-white `}
      style={{ height: height ? height : "calc(100vh - 14rem)" }}
      id="scroll_style"
    >
      <div className={`${classes.tablecontainer_div}`}>
        <table
          border={1}
          style={{
            width: "100%",
            borderCollapse: "separate",
            borderSpacing: 0,
          }}
          className="customers_table"
        >
          <thead className="">
            <tr>
              {columns.map((col, index) => (
                <th
                  key={String(col.key)}
                  className={`p-3 bg-oceangreen
                  ${col.type === "NUMBER" ? "text-right" : "text-left"}
                  ${col.headerClassName}
                  ${col.className}
                `}
                >
                  {col.headerWidget ? col.headerWidget : col.header}
                </th>
              ))}
            </tr>
          </thead>

          <tbody>
            {loading ? (
              [...Array(16)].map((_, rowIndex) => (
                <tr key={rowIndex}>
                  {columns.map((col, colIndex) => (
                    <td
                      key={`${rowIndex}-${colIndex}`}
                      className={`p-3 ${col.className || ""}`}
                    >
                      <div className="h-4 w-full animate-pulse rounded bg-gray-200" />
                    </td>
                  ))}
                </tr>
              ))
            ) : data.length > 0 ? (
              data.map((row: any, rowIndex) => (
                <React.Fragment key={rowIndex}>
                  <tr
                    key={rowIndex}
                    className="bg-white cursor-pointer"
                    onClick={(e) => {
                      const target = e.target as HTMLElement;

                      if (
                        target.closest("button") ||
                        target.closest("input") ||
                        target.closest("select") ||
                        target.closest("a")
                      ) {
                        return;
                      }

                      if (rowClickAction === "expand") {
                        if (isRowExpandable?.(row)) toggleRow(rowIndex);
                      } else if (rowClickAction === "navigate") {
                        onRowClick?.(row);
                      }
                    }}
                  >
                    {columns.map((col) => {
                      const value = row[col.key];
                      return (
                        <td
                          key={String(col.key)}
                          className={`p-3 ${col.className || ""}
                          ${col.type === "NUMBER" ? "text-right" : ""}
                          ${col.key === "sNo" ? "text-center" : ""}
                          ${isRowExpandable?.(row) && expandedRows.has(rowIndex)
                              ? "bg-oceangreen"
                              : "bg-white"
                            }
                          `}
                        >
                          {col.key === "sNo" ? (
                            <div className="w-full text-center">
                              {rowIndex + 1}
                            </div>
                          ) : col.render ? (
                            col.render(value, row, rowIndex, expandedRows.has(rowIndex))
                          ) : col.type === "ELEMENT" ? (
                            value
                          ) : col.type === "NUMBER" ? (
                            <div className="w-full text-right">{value}</div>
                          ) : (
                            <div className="w-full">{String(value)}</div>
                          )}
                        </td>
                      );
                    })}
                  </tr>
                  {isRowExpandable?.(row) && expandedRows.has(rowIndex) && (
                    <tr>
                      <td colSpan={columns.length} className="p-1">
                        {renderExpandedRow?.(row)}
                      </td>
                    </tr>
                  )}
                </React.Fragment>
              ))
            ) : (
              <tr>
                <td
                  colSpan={columns.length}
                  className="text-center py-10 bg-white"
                >
                  <div className="flex flex-col items-center justify-center">
                    <img
                      src={NodataAvailable}
                      alt="No Data"
                      className="mx-auto py-5"
                    />
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
